export default "__VITE_ASSET__CCv56OGP__"